var $export = require('./_export')
  , $task   = require('./_task');
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});


//////////////////
// WEBPACK FOOTER
// /home/readymade/apps/facelift_production/shared/~/core-js/modules/web.immediate.js
// module id = 742
// module chunks = 0